import useDfpSlot from "../../hooks/useDfpSlot";

const LoadNewsAndArticlesListingAds = () => {
    useDfpSlot([{
        path: "/22240682100/ROS_Footer1_300x250",
        size: [300, 250],
        id: "div-gpt-ad-1628625252827-0",
      },{
        path: "/22240682100/ROS_Footer2_300x250",
        size: [300, 250],
        id: "div-gpt-ad-1628625323242-0",
      },{
        path: "/22240682100/ROS_Footer3_300x250",
        size: [300, 250],
        id: "div-gpt-ad-1628625359907-0",
      },{
        path: "/22240682100/ROS_Footer4_300x250",
        size: [300, 250],
        id: "div-gpt-ad-1628625430383-0",
      },{
        path: "/22240682100/Top_Banner_970x90",
        size: [970, 90],
        id: "div-gpt-ad-1611326459208-0",
      },{
        path: "/22240682100/Top_300x50_mobile",
        size: [300, 50],
        id: "div-gpt-ad-1611693088874-0",
      },{
        path: "/22240682100/Content_Banner_1_970x90",
        size: [970, 90],
        id: "div-gpt-ad-1649701637206-0",
      },{
        path: "/22240682100/Content_Banner_1_300x50_Mobile",
        size: [300, 50],
        id: "div-gpt-ad-1649701809430-0",
      },{
        path: "/22240682100/Content_Banner_2_970x90",
        size: [970, 90],
        id: "div-gpt-ad-1649701921828-0",
      },{
        path: "/22240682100/Content_Banner_2_300x50_Mobile",
        size: [300, 50],
        id: "div-gpt-ad-1649701861184-0",
      },{
        path: "/22240682100/Content_Banner_3_970x90",
        size: [970, 90],
        id: "div-gpt-ad-1649702008484-0",
      },{
        path: "/22240682100/Content_Banner_3_300x50_Mobile",
        size: [300, 50],
        id: "div-gpt-ad-1649702035816-0",
      }]);

    return(<></>)
}

export default LoadNewsAndArticlesListingAds;